<template>
  <a
    data-toggle="modal"
    @click="onClickEdit"
    :class="[options.class, 'edit-icon-link']"
    :data-target="options.target"
    ><i class="ag-icon ag-icon_edit_icon"  title="Edit"  style="width: 25px !important; height: 24px !important;"></i
  ></a>
</template>

<script setup >
import { defineEmits, defineProps } from "vue";

const emit = defineEmits(['edit'])

function onClickEdit() {
  emit('edit')
}

const props = defineProps({
  data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
})
</script>
<style scoped>
.edit-icon-link{
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease, transform 0.2s ease;
}
.edit-icon-link:hover{
  background-color: rgba(76, 141, 187, 0.12);
  transform: translateY(-1px);
}
.edit-icon-link:active{
  transform: translateY(0);
}
.edit-icon-link .ag-icon{
  transition: color 0.2s ease, filter 0.2s ease;
}
.edit-icon-link:hover .ag-icon{
  color: #2f6f99;
  filter: brightness(0.9);
}
</style>